'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_lifecycle_MountContext(thisNode, owner) {
  this.lz = null;
  this.z7 = null;
  this.lz = thisNode;
  this.z7 = owner;
}
export { $c_Lcom_raquo_laminar_lifecycle_MountContext as $c_Lcom_raquo_laminar_lifecycle_MountContext };
$p = $c_Lcom_raquo_laminar_lifecycle_MountContext.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_lifecycle_MountContext;
/** @constructor */
function $h_Lcom_raquo_laminar_lifecycle_MountContext() {
}
export { $h_Lcom_raquo_laminar_lifecycle_MountContext as $h_Lcom_raquo_laminar_lifecycle_MountContext };
$h_Lcom_raquo_laminar_lifecycle_MountContext.prototype = $p;
var $d_Lcom_raquo_laminar_lifecycle_MountContext = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_lifecycle_MountContext, "com.raquo.laminar.lifecycle.MountContext", ({
  ip: 1
}));
export { $d_Lcom_raquo_laminar_lifecycle_MountContext as $d_Lcom_raquo_laminar_lifecycle_MountContext };
